import { render, staticRenderFns } from "./CurrentAlarmTable.vue?vue&type=template&id=2232c31e&"
import script from "./CurrentAlarmTable.vue?vue&type=script&lang=js&"
export * from "./CurrentAlarmTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports